import { faInfoSquare } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';
import { CheckboxHelp } from 'mk2/apps/strollers/containers/StrollersSearch/CheckboxHelp';
import { CheckboxField } from 'mk2/components/forms/CheckboxField';
import { isASTEmpty } from 'mk2/helpers/article_ast/filters';
import useEventCallback from 'mk2/hooks/useEventCallback';
import { ContentItemEntity } from 'mk2/schemas';
import React, { useState } from 'react';
import styles from './CheckboxFieldWithCount.mscss';

interface OwnProps {
    name: string;
    count?: number;
    label: string;
    help?: ContentItemEntity;
}

type Props = OwnProps;

export const CheckboxFieldWithCount: React.FunctionComponent<Props> = ({
    name, label, count, help,
}) => {
    const hasHelp = help && !isASTEmpty(help.contentAST);
    const [helpDisplayed, setHelpDisplayed] = useState(false);

    const onHelpToggle = useEventCallback(
        (event: React.MouseEvent<HTMLSpanElement>) => {
            event.preventDefault();
            event.stopPropagation();
            setHelpDisplayed((s) => !s);
        },
        [setHelpDisplayed],
    );

    return (
        <>
            <CheckboxField
                bottomBorder={!helpDisplayed}
                className={styles.CheckboxFieldWithCount}
                name={name}
                label={
                    <>
                        <span className={styles.CheckboxFieldWithCount__label}>{label}</span>
                        {hasHelp && (
                            <span
                                onClick={onHelpToggle}
                                className={cx(
                                    styles.CheckboxFieldWithCount__help,
                                    helpDisplayed && styles['CheckboxFieldWithCount__help--active'],
                                )}
                            >
                                <FontAwesomeIcon icon={faInfoSquare} />
                            </span>
                        )}
                        <span className={styles.CheckboxFieldWithCount__count}>{count}</span>
                    </>
                }
            />
            {helpDisplayed && <CheckboxHelp help={help} />}
        </>
    );
};

CheckboxFieldWithCount.displayName = 'CheckboxFieldWithCount';
